"use client";

import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import { useFormStatus } from "react-dom";

import { Button } from "./ui/button";

export function SubmitButton({
  children,
  variant,
  className,
  disabled,
  ...props
}: { children: ReactNode } & ComponentPropsWithoutRef<typeof Button>) {
  const { pending } = useFormStatus();
  return (
    <Button
      variant={variant ?? "outline"}
      className={className ?? "w-full rounded-full"}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={disabled || pending}
      {...props}
    >
      {children}
    </Button>
  );
}
